import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PATHS } from '@/config/paths';

/**
 * Shown when the user is authenticated but lacks permission for a route or ops area.
 */
export function ForbiddenPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex h-screen items-center justify-center bg-[var(--bg-primary)]">
      <Result
        status="403"
        title="403"
        subTitle={t('errors.forbiddenSubtitle')}
        extra={
          <Button type="primary" onClick={() => navigate(PATHS.HOME)}>
            {t('errors.backToMap')}
          </Button>
        }
      />
    </div>
  );
}
